import { forwardRef, ReactElement } from 'react';

// Solution from https://www.totaltypescript.com/forwardref-with-generic-components

/*
TypeScript sometimes requires type approval as never when working with combinations of functions with incompatible parameter types.
The implementation of React forwardRef in TypeScript has limitations, including disabling output for generic components.
The problem occurs when adding a reference to component where generic type stops working.
The solution is to redefine forwardRef using a different type definition, which allows the component to work correctly.

TODO: Delete this function after nuking the onboarding forms
*/
export function fixedForwardRef<T, P = object>(
  render: (props: P, ref: React.Ref<T>) => ReactElement
): (props: P & React.RefAttributes<T>) => ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return forwardRef(render as any) as any;
}
